import { Box, Typography } from "@mui/material";
import { LegitCheckItem } from "../../types/types";
import UserNameBasic from "../UserName/UserNameBasic";
import ProfileImg from "../ProfileImg/ProfileImg";
import defaultAvatarImg from "../../img/defaultProfile.jpg";

interface LegitCheckResultElementProps {
  legitCheck: LegitCheckItem;
}

const LegitCheckResultElement = ({
  legitCheck,
}: LegitCheckResultElementProps) => {
  const legitElement = (
    <Typography
      variant="body1"
      sx={{
        color: "#07b628 !important",
        fontWeight: "700 !important",
        fontSize: "1.2rem !important",
      }}
    >
      Legit
    </Typography>
  );
  const notLegitElement = (
    <Typography
      variant="body1"
      sx={{
        color: "#fb2323 !important",
        fontWeight: "700 !important",
        fontSize: "1.2rem !important",
      }}
    >
      Not Legit
    </Typography>
  );

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexWrap: "wrap",
        marginBottom: "1.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: { xs: "100%", md: "40%" },
          marginTop: "10px",
        }}
      >
        <Box sx={{ marginRight: "10px" }}>
          <ProfileImg
            imgUrl={
              legitCheck.user.profile_image?.url
                ? legitCheck.user.profile_image.url
                : defaultAvatarImg
            }
            size={50}
          />
        </Box>
        <Box>
          <Box>
            <UserNameBasic
              name={legitCheck.user.username}
              role={legitCheck.user.role.id}
              variant="followCardUserName"
              justifyContent="start"
            />
          </Box>
          <Box>
            <Typography
              variant="body1"
              sx={{
                color: "#4663ff !important",
                fontSize: "0.8rem !important",
              }}
            >
              {legitCheck.user.shirt_count} shirts
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "calc(60% - 15px)" },
          marginTop: { xs: "16px", md: "0px" },
        }}
      >
        <Box sx={{ marginBottom: "5px" }}>
          {legitCheck.is_legit === true ? legitElement : notLegitElement}
        </Box>
        <Box>
          <Typography variant="body1">{legitCheck.comment}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default LegitCheckResultElement;
